// extracted by mini-css-extract-plugin
export var button = "latestVideos-module--button--3bfc3";
export var container = "latestVideos-module--container--1aaa5";
export var heading = "latestVideos-module--heading--6d12b";
export var subheading = "latestVideos-module--subheading--f5ce5";
export var video = "latestVideos-module--video--f96cd";
export var videoBlock = "latestVideos-module--video-block--8c41e";
export var videoTitle = "latestVideos-module--video-title--edc10";
export var videos = "latestVideos-module--videos--e1279";